// extracted by mini-css-extract-plugin
export default {"card":"Card-module__card__rJXdi"};